import { Logo } from '@/components/logo';
import { useLayoutContext } from '@/contexts';
import { safeAreaTop } from '@/utils';
import { Flex, Space } from '@mantine/core';
import styles from './styles.module.css';

export interface SplashHeaderProps {
	children?: React.ReactNode;
	withLogo?: boolean;
}

export const SplashHeader = ({ children, withLogo }: SplashHeaderProps) => {
	const includeLogo = withLogo ?? true;
	const { isDesktop } = useLayoutContext();
	const notchPadding = safeAreaTop();

	return (
		<Flex
			direction="column"
			align="center"
			justify="flex-start"
			h={isDesktop ? '350px' : '27vh'}
			className={styles.splash}
			pt="xl"
		>
			{notchPadding > 0 && <Space h={notchPadding} />}
			{includeLogo && <Logo />}
			<Space h={20} />
			{children}
			{notchPadding > 0 && <Space h={20} />}
		</Flex>
	);
};
